import { EmployeeUserRepo } from 'ehawker/src/data/repositories/EmployeeUserRepo';

/**
 * List of data to be fetched regularly
 */
export async function fetchData() {
  if (!(await EmployeeUserRepo.getUser())) return;
  return Promise.all([]);
}
